import React from 'react';
export const useRhfTransformInterpolation = (value, transform) => {
  const selection = React.useRef(null);
  React.useEffect(() => {
    if (transform && selection.current) {
      selection.current();
      selection.current = null;
    }
  }, [value]);
  const interpolation = React.useCallback(e => {
    const change = e.target.value;
    if (transform) {
      var _e$target$selectionSt;
      const selectionIndex = (_e$target$selectionSt = e.target.selectionStart) !== null && _e$target$selectionSt !== void 0 ? _e$target$selectionSt : 0;
      const final = transform(change);
      const offset = final.length === change.length ? 0 : final.length < change.length ? -1 : 1;
      selection.current = () => {
        const index = selectionIndex + offset;
        e.target.setSelectionRange(index, index);
      };
      if (offset === -1) setTimeout(() => {
        if (selection.current) {
          selection.current();
          selection.current = null;
        }
      }, 0);
      return final;
    }
    return change;
  }, [transform]);
  return interpolation;
};